import { useEffect, useRef, useState } from "react";

import AspectRatio from "./AspectRatio";
import PropTypes from "prop-types";
import aspectRatioStyles from "./AspectRatio.module.css";
import classNames from "classnames";
import loaderStyles from "./Loader.module.css";

// NB the 639px and 640px values here must match what is set in the AspectRatio.module.css file

export default function ResponsiveImageBlock({ imgDesktop, imgMobile }) {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current !== null) {
      if (ref.current.complete) {
        setLoaded(true);
      }
    }
  }, [ref, setLoaded]);

  return (
    <AspectRatio
      ratioMobile={imgMobile.height / imgMobile.width}
      ratioDesktop={imgDesktop.height / imgDesktop.width}
      backgroundColor="var(--off-light)"
    >
      <picture>
        <source media="(max-width: 639px)" srcSet={imgMobile.srcSet} />
        <source media="(min-width: 640px)" srcSet={imgDesktop.srcSet} />
        <img
          className={classNames({
            [aspectRatioStyles.fitted]: true,
            [loaderStyles.loader]: true,
            [loaderStyles.loading]: !loaded,
            [loaderStyles.loaded]: loaded,
          })}
          src={imgDesktop.src}
          ref={ref}
          sizes="100vw"
          alt={imgDesktop.title}
          width={800}
          height={450}
          onLoad={() => {
            setLoaded(true);
          }}
        />
      </picture>
    </AspectRatio>
  );
}

ResponsiveImageBlock.propTypes = {
  imgDesktop: PropTypes.shape({
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
  imgMobile: PropTypes.shape({
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
};
